module.exports = __webpack_public_path__ + "img/5.1-Table-Fruit-Faded.18b179fd.png";